export const indexCol = {
  id: "index",
  header: "#",
  size: 45,
  minSize: 45,
  maxSize: 45,

  grow: false,

  enableSorting: false,
  enableColumnFilter: false,
  enableEditing: false,

  muiTableHeadCellProps: {
    align: "center",
  },
  muiTableBodyCellProps: {
    align: "center",
  },

  Cell: ({ row, table }) => {
    return (
      table.getState().pagination.pageIndex *
        table.getState().pagination.pageSize +
      row.index +
      1
    );
  },
};
